
import Loading from '@/components/Loading.vue'
import ProductListItem from '@/components/ProductListItem'
import CategoryStructuredData from '@/components/CategoryStructuredData'
import productListMixin from '@/mixins/productListMixin.js'
import FilterModal from '@/components/FilterModal'
import FilterList from '@/components/FilterList'
import ProductListToolbar from '@/components/ProductListToolbar.vue'
import filterListMixin from '@/mixins/filterListMixin'
import {
  TECHNICAL_FILTER_QUERY_KEYS,
  activeTechnicalFiltersCount,
} from '@/utils/technicalFilters'
import {
  readProductDisplayMode,
  writeProductDisplayMode,
} from '@/utils/productDisplayModeStorage'

export default {
  name: 'ProductList',
  components: {
    ProductListItem,
    CategoryStructuredData,
    Loading,
    FilterModal,
    FilterList,
    ProductListToolbar,
  },
  mixins: [productListMixin, filterListMixin],
  props: {
    category: {
      default: null,
      type: Object,
    },
    cols: {
      default: 3,
      type: [Number, String],
    },
    sortable: {
      default: true,
      type: Boolean,
    },
    cartMetadata: {
      type: Object,
      default: null,
    },
    nameIsH2: {
      type: Boolean,
      default: true,
    },
    enableDisplayModeToggle: {
      type: Boolean,
      default: false,
    },
    enableVehicleSelector: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filtersSidebarOpen: false,
      displayMode: 'classic',
    }
  },
  computed: {
    isLoading() {
      return !!(this.$fetchState.pending || this.$store.state.loading_products)
    },
    showToolbar() {
      return !!(
        !this.$route.query.q ||
        this.someFiltersPresents ||
        this.isLoading ||
        this.products?.length
      )
    },
    hasTechnicalFilters() {
      return activeTechnicalFiltersCount(this.$route.query) > 0
    },
    numberOfPages() {
      return Math.max(1, Math.ceil(this.total_products / this.limit))
    },
    someFiltersPresents() {
      return (
        this.$route.query.filters ||
        this.$route.query.categories ||
        this.$route.query.technologie ||
        this.$route.query.type ||
        this.$route.query.brands ||
        this.$route.query.price ||
        this.$route.query.reviews ||
        TECHNICAL_FILTER_QUERY_KEYS.some(key => this.$route.query[key])
      )
    },
    filtersSelectedSum() {
      return (
        (this.$route.query.filters
          ? this.$route.query.filters.split(',').length
          : 0) +
        (this.$route.query.categories
          ? this.$route.query.categories.split(',').length
          : 0) +
        (this.$route.query.species
          ? this.$route.query.species.split(',').length
          : 0) +
        (this.$route.query.price ? 1 : 0) +
        (this.$route.query.type ? 1 : 0) +
        (this.$route.query.brands
          ? this.$route.query.brands.split(',').length
          : 0) +
        (this.$route.query.availability
          ? this.$route.query.availability.split(',').length
          : 0) +
        (this.$route.query.technologie ? 1 : 0) +
        (this.$route.query.reviews ? 1 : 0) +
        activeTechnicalFiltersCount(this.$route.query)
      )
    },
  },
  watch: {
    total_products(val) {
      this.$emit('products-loaded', {
        total: val,
        products: this.products,
      })
    },
    displayMode(val) {
      writeProductDisplayMode(val)
    },
    '$route.query'() {
      this.filtersSidebarOpen = false
    },
  },
  mounted() {
    if (!this.enableDisplayModeToggle) return

    const saved = readProductDisplayMode()
    if (saved) this.displayMode = saved
  },
  methods: {
    removeProduct(productId) {
      this.products = (this.products || []).filter(
        product => product.id !== productId
      )
      this.total_products = Math.max(0, this.total_products - 1)
    },
    appendProduct(product) {
      this.products = [...(this.products || []), product]
      this.total_products += 1
    },
    pageLink(pageNumber) {
      return this.localePath({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: pageNumber === 1 ? undefined : String(pageNumber),
        },
      })
    },
    cancelSearch() {
      this.$router.push(
        this.localePath({
          path: this.$route.path,
          query: undefined,
        })
      )
    },
    deSlugify(value) {
      if (!value) return ''
      return value.replace(/-/g, ' ')
    },
  },
}
